export default __webpack_public_path__ + "static/media/cognota-avatar.4f750417.svg";